import script from "./CampaignDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./CampaignDashboard.vue?vue&type=script&setup=true&lang=js"

import "./CampaignDashboard.vue?vue&type=style&index=0&id=59829a0e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59829a0e"]])

export default __exports__